import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

export type UiCloseEvent = 'confirm' | 'dismiss';

@Component({
    selector: 'ui-persistent-notification',
    templateUrl: './ui-persistent-notification.html',
    styleUrls: ['./ui-persistent-notification.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    // tslint:disable-next-line: no-host-metadata-property
    host: {
        class: 'ui-persistent-notification-container',
    },
})
export class UiPersistentNotificationComponent {
    @Input()
    public message = '';

    @Input()
    public buttonLabel = '';

    @Input()
    public show = false;

    @Output()
    public closed = new EventEmitter<UiCloseEvent>();

    public confirm() {
        this.show = false;
        this.closed.emit('confirm');
    }

    public dismiss() {
        this.show = false;
        this.closed.emit('dismiss');
    }
}
